<div class="back-button-container">
  <gb-icon icon="arrow-back"> </gb-icon>
  <span [translate]="labelTranslateKey"></span>
</div>
